import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';



import { MatSelectModule } from '@angular/material/select';
import { OfficerSearchDetailsComponent } from './officer-search-details.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { OfficerSearchService } from './officer-search.service';


@NgModule({
    declarations: [
        OfficerSearchDetailsComponent

    ],
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        MatSelectModule,
        MatRadioModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule
    ],
    providers: [OfficerSearchService],
    exports: [
        MatSelectModule,
        MatRadioModule

    ]
})
export class  OfficerSearchDetailsModule { }
